import MOSTUSEDTECHSBYOTHER from 'data/mantechcar25/most-used-techs-by-other.json';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const MostUsedTechsByOther: React.FC = () => {
  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400} width="99%" minWidth={500}>
          <BarChart data={MOSTUSEDTECHSBYOTHER} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              domain={[0, 6]}
              tickFormatter={(tick) => {
                return `${tick.toFixed(1)}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="name"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MostUsedTechsByOther;
